import "core-js/modules/es.string.sub.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import PropTypes from 'prop-types';
import { convertToAdditionalCurrency } from 'utils';
import { kpiGrid, kpiCard } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var KpiCard = function KpiCard(_ref) {
  var label = _ref.label,
      value = _ref.value,
      sub = _ref.sub,
      badge = _ref.badge,
      color = _ref.color;
  return ___EmotionJSX("div", {
    css: kpiCard(color)
  }, ___EmotionJSX("p", {
    className: "kpi-label"
  }, label), ___EmotionJSX("p", {
    className: "kpi-value"
  }, value), sub && ___EmotionJSX("p", {
    className: "kpi-sub"
  }, sub), badge && ___EmotionJSX("span", {
    className: "kpi-badge"
  }, badge));
};

KpiCard.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  sub: PropTypes.string,
  badge: PropTypes.string,
  color: PropTypes.string
};

var formatAmount = function formatAmount(val) {
  var cur = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'EUR';
  var num = Number(val || 0);
  return "".concat(num.toLocaleString('bg-BG', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }), " ").concat(cur);
};

var KpiCards = function KpiCards(_ref2) {
  var _data$credit_counts$a, _data$credit_counts, _data$credit_counts$d, _data$credit_counts2, _data$overdue_summary, _data$overdue_summary2, _data$collections_thi, _data$collections_thi2, _data$credits_issued_, _data$credits_issued_2, _data$active_portfoli, _data$active_portfoli2, _data$overdue_summary3, _data$credits_issued_3;

  var data = _ref2.data,
      showFunds = _ref2.showFunds,
      _ref2$currency = _ref2.currency,
      currency = _ref2$currency === void 0 ? 'EUR' : _ref2$currency;
  if (!data) return null;
  var activeCount = ((_data$credit_counts$a = (_data$credit_counts = data.credit_counts) === null || _data$credit_counts === void 0 ? void 0 : _data$credit_counts.active) !== null && _data$credit_counts$a !== void 0 ? _data$credit_counts$a : 0) + ((_data$credit_counts$d = (_data$credit_counts2 = data.credit_counts) === null || _data$credit_counts2 === void 0 ? void 0 : _data$credit_counts2.delayed) !== null && _data$credit_counts$d !== void 0 ? _data$credit_counts$d : 0);
  var overdueCount = (_data$overdue_summary = (_data$overdue_summary2 = data.overdue_summary) === null || _data$overdue_summary2 === void 0 ? void 0 : _data$overdue_summary2.count) !== null && _data$overdue_summary !== void 0 ? _data$overdue_summary : 0;
  var collectedTotal = (_data$collections_thi = (_data$collections_thi2 = data.collections_this_month) === null || _data$collections_thi2 === void 0 ? void 0 : _data$collections_thi2.total) !== null && _data$collections_thi !== void 0 ? _data$collections_thi : '0';
  var issuedCount = (_data$credits_issued_ = (_data$credits_issued_2 = data.credits_issued_this_month) === null || _data$credits_issued_2 === void 0 ? void 0 : _data$credits_issued_2.count) !== null && _data$credits_issued_ !== void 0 ? _data$credits_issued_ : 0;
  var portfolioAmount = (_data$active_portfoli = (_data$active_portfoli2 = data.active_portfolio) === null || _data$active_portfoli2 === void 0 ? void 0 : _data$active_portfoli2.total_principal) !== null && _data$active_portfoli !== void 0 ? _data$active_portfoli : '0';
  return ___EmotionJSX("div", {
    style: kpiGrid
  }, ___EmotionJSX(KpiCard, {
    label: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438 \u043A\u0440\u0435\u0434\u0438\u0442\u0438",
    value: activeCount,
    sub: formatAmount(portfolioAmount, currency),
    badge: "".concat(issuedCount, " \u043D\u043E\u0432\u0438 \u0442\u043E\u0437\u0438 \u043C\u0435\u0441\u0435\u0446"),
    color: "success"
  }), ___EmotionJSX(KpiCard, {
    label: "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u0438",
    value: overdueCount,
    sub: formatAmount((_data$overdue_summary3 = data.overdue_summary) === null || _data$overdue_summary3 === void 0 ? void 0 : _data$overdue_summary3.total_due_amount, currency),
    color: "error"
  }), ___EmotionJSX(KpiCard, {
    label: "\u0421\u044A\u0431\u0440\u0430\u043D\u043E \u0442\u043E\u0437\u0438 \u043C\u0435\u0441\u0435\u0446",
    value: formatAmount(collectedTotal, currency),
    sub: convertToAdditionalCurrency({
      value: collectedTotal,
      fromCurrency: currency
    }),
    color: "primary"
  }), showFunds && ___EmotionJSX(KpiCard, {
    label: "\u0418\u0437\u0434\u0430\u0434\u0435\u043D\u0438 \u0442\u043E\u0437\u0438 \u043C\u0435\u0441\u0435\u0446",
    value: issuedCount,
    sub: formatAmount((_data$credits_issued_3 = data.credits_issued_this_month) === null || _data$credits_issued_3 === void 0 ? void 0 : _data$credits_issued_3.amount, currency),
    color: "info"
  }));
};

KpiCards.propTypes = {
  data: PropTypes.object,
  showFunds: PropTypes.bool,
  currency: PropTypes.string
};
export default KpiCards;